export interface IEquityMovementScheduleFli {
    fliName: string;
    fliDescriptionToDisplay: string;
    previousYearOpeningBalance?: number;
    currentYearOpeningBalance: number;
    currentYearClosingBalance: number;
}
